// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wz-z","tooltipWrapper":"xz-z","icon":"yz-z","tooltip":"zz-z","content":"Az-z"};